export const MENU_DATA = [
  {
    id: "001",
    name: "HỆ THỐNG",
    url: "/he_thong",
    isCompany: 0,
    sortOrder: 1,
    parentID: null,
    uniqueCode: "System",
    status: 1,
    isCategory: true,
  },
  {
    id: "002",
    name: "QUẢN LÝ DOANH NGHIỆP",
    url: "/quan_ly_doanh_nghiep",
    isCompany: 0,
    sortOrder: 2,
    parentID: null,
    uniqueCode: "CompanyManagement",
    status: 1,
    isCategory: true,
  },
  {
    id: "003",
    name: "QUẢN LÝ DOANH MỤC",
    url: "/quan_ly_danh_muc",
    isCompany: 0,
    sortOrder: 3,
    parentID: null,
    uniqueCode: "IndexManagement",
    status: 1,
    isCategory: true,
  },
  {
    id: "004",
    name: "QUẢN LÝ TEM",
    url: "/quan_ly_tem_truy_xuat",
    isCompany: 0,
    sortOrder: 4,
    parentID: null,
    uniqueCode: "StampSeries",
    status: 1,
    isCategory: true,
  },
  {
    id: "005",
    name: "QUẢN LÝ SẢN PHẨM",
    url: "/quan_ly_thu",
    isCompany: 0,
    sortOrder: 5,
    parentID: null,
    uniqueCode: "Financial",
    status: 1,
    isCategory: true,
  },
  {
    id: "007",
    name: "BÁO CÁO",
    url: "/bao_cao_tong_hop",
    isCompany: 0,
    sortOrder: 7,
    parentID: null,
    uniqueCode: "SummaryReports",
    status: 1,
    isCategory: true,
  },
  {
    id: "007",
    name: "Người dùng",
    url: "/tai_khoan_nguoi_dung",
    isCompany: 0,
    sortOrder: 1,
    parentID: "001",
    uniqueCode: "Users",
    status: 1,
  },
  {
    id: "008",
    name: "Nhóm quyền",
    url: "/nhom_quyen",
    isCompany: 0,
    sortOrder: 2,
    parentID: "001",
    uniqueCode: "Roles",
    status: 1,
  },
  {
    id: "009",
    name: "Phân quyền",
    url: "/phan_quyen_chuc_nang",
    isCompany: 0,
    sortOrder: 3,
    parentID: "001",
    uniqueCode: "Permissions",
    status: 1,
  },
  {
    id: "010",
    name: "Quản lí thông tin DN/CN",
    url: "/quan_ly_thong_tin_dn",
    isCompany: 0,
    sortOrder: 4,
    parentID: "002",
    uniqueCode: "BusinessInformations",
    status: 1,
  },
  {
    id: "012",
    name: "Loại vùng sản xuất",
    url: "/loai_vung_trong_va_thuoc_tinh",
    isCompany: 0,
    sortOrder: 5,
    parentID: "003",
    uniqueCode: "PlantingTypes",
    status: 1,
  },
  {
    id: "013",
    name: "Vùng sản xuất",
    url: "/vung_trong",
    isCompany: 0,
    sortOrder: 6,
    parentID: "003",
    uniqueCode: "PlantingZones",
    status: 1,
  },
  {
    id: "014",
    name: "Nguyên vật liệu",
    url: "/quan_ly_nguyen_vat_lieu",
    isCompany: 0,
    sortOrder: 7,
    parentID: "005",
    uniqueCode: "MaterialManagements",
    status: 1,
  },
  {
    id: "015",
    name: "Hàng hoá sản phẩm",
    url: "/quan_ly_hang_hoa",
    isCompany: 0,
    sortOrder: 8,
    parentID: "005",
    uniqueCode: "ProductManagements",
    status: 1,
  },
  {
    id: "016",
    name: "Nhập hàng hoá, NVL",
    url: "/nhap_hang_hoa",
    isCompany: 0,
    sortOrder: 9,
    parentID: "005",
    uniqueCode: "ImportProducts",
    status: 1,
  },
  {
    id: "017",
    name: "Xuất hàng hoá, NVL",
    url: "/xuat_hang_hoa",
    isCompany: 0,
    sortOrder: 9,
    parentID: "005",
    uniqueCode: "ExportProducts",
    status: 1,
  },
  {
    id: "018",
    name: "Quản lí tồn kho",
    url: "/ton_kho",
    isCompany: 0,
    sortOrder: 10,
    parentID: "007",
    uniqueCode: "InventoryManagements",
    status: 1,
  },
  {
    id: "019",
    name: "Tồn kho phiếu điều chỉnh",
    url: "/phieu_dieu_chinh",
    isCompany: 0,
    sortOrder: 11,
    parentID: "007",
    uniqueCode: "AdjustmentManagements",
    status: 1,
  },
  {
    id: "020",
    name: "Tồn kho xuất chuyển",
    url: "/xuat_chuyen",
    isCompany: 0,
    sortOrder: 11,
    parentID: "007",
    uniqueCode: "ExportManagements",
    status: 1,
  },
  {
    id: "021",
    name: "Tồn kho nhập chuyển",
    url: "/nhap_chuyen",
    isCompany: 0,
    sortOrder: 12,
    parentID: "007",
    uniqueCode: "ImportManagements",
    status: 1,
  },
  {
    id: "022",
    name: "Nhật ký truy xuất",
    url: "/nhat_ky",
    isCompany: 0,
    sortOrder: 14,
    parentID: "007",
    uniqueCode: "LoggingInformations",
    status: 1,
  },
  {
    id: "023",
    name: "Truy xuất thông tin",
    url: "/truy_xuat_thong_tin",
    isCompany: 0,
    sortOrder: 15,
    parentID: "007",
    uniqueCode: "RetrieveInformations",
    status: 1,
  },
  {
    id: "024",
    name: "Kê khai thông tin",
    url: "/ke_khai_thong_tin",
    isCompany: 0,
    sortOrder: 16,
    parentID: "007",
    uniqueCode: "DeclarationInformations",
    status: 1,
  },
  {
    id: "025",
    name: "Xin cấp tem, in tem",
    url: "/xin_cap_tem",
    isCompany: 0,
    sortOrder: 16,
    parentID: "004",
    uniqueCode: "StampRequestUseds",
    status: 1,
  },
  {
    id: "026",
    name: "Quản lí lô hàng & gán tem",
    url: "/quan_ly_lo_hang",
    isCompany: 0,
    sortOrder: 17,
    parentID: "004",
    uniqueCode: "Products",
    status: 1,
  },
  {
    id: "027",
    name: "Quản lí mã QR",
    url: "/quan_ly_qr",
    isCompany: 0,
    sortOrder: 19,
    parentID: "004",
    uniqueCode: "QrCodeManagements",
    status: 1,
  },
  {
    id: "028",
    name: "Báo cáo",
    url: "/bao_cao_tong_hop",
    isCompany: 0,
    sortOrder: 20,
    parentID: "007",
    uniqueCode: "SummaryReport",
    status: 1,
  },
];
